module.exports = __webpack_public_path__ + "img/lg_hkws.119366bf.png";